<template>
  <div class="pageContol studentList">
    <div class="framePage">
      <div class="framePage-title">
        <span>
          <em>当前位置：</em>
          <a href="javascript:;">考试管理</a>
          <i>></i>
          <a href="javascript:;" @click="$router.back()">考试仓管理</a>
          <i>></i>
          <a href="javascript:;" class="cur-a">{{ pageDatas.examinationId ? '编辑' : '新建' }}</a>
        </span>
      </div>
      <div class="framePage-body">
        <div class="framePage-scroll">
          <div class="ovy-a">
            <el-form ref="pageDatas" label-width="100px" class="demo-ruleForm form-box" size="small"
              :rules="pageDatasRules" :model="pageDatas">
              <el-form-item label="考试仓名称" prop="houseName">
                <el-input v-model="pageDatas.houseName" placeholder="请输入考试仓名称"></el-input>
              </el-form-item>
              <el-form-item label="考试仓地址" prop="address">
                <el-input type="textarea" rows="8" resize="none" style="width: 100%; max-width: 500px"
                          maxlength="200" show-word-limit placeholder="请输入考试仓地址" v-model="pageDatas.address"></el-input>
              </el-form-item>
              <el-form-item label="考试场地：">
                <el-select
                  v-model="pageDatas.examAreaId"
                  placeholder="请选择"
                  size="small"
                >
                  <el-option
                    v-for="item in examAreas"
                    :key="item.examAreaId"
                    :label="item.areaName"
                    :value="item.examAreaId"
                  >
                  </el-option>
                </el-select>
            </el-form-item>
            </el-form>
            <div class="btn-box flexcc">
              <el-button class="bgc-bv" size="small" @click="cancelSave(2)">取 消</el-button>
              <el-button class="bgc-bv" size="small" @click="cancelSave(1)">确 定</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import E from "wangeditor";
let editor = {};
export default {
  name: "examination_examHouseAddEdit",
  components: {},
  data() {
    return {
      // 页面数据
      pageDatas: {
        examHouseId: "", // 考试公告id
        houseName: "", // 公告名称
        address: "", // 公告内容
        examAreaId: null
      },
      // 页面数据 - 数据校验
      pageDatasRules: {
        houseName: [
          { required: true, trigger: "blur", message: "请输入考试仓名称" },
        ],
        address: [
          { required: true, trigger: "blur", message: "请输入考试仓地址" },
        ],
      },
      // 考试区域下拉列表
      examAreas: [],
    };
  },
  created() {
    this.$post("/biz/isec/exam-area/queryAll", {}, 3000, true, 6)
      .then((res) => {
        this.examAreas = {
          ...res.data
        }
        
      })
      .catch((err) => {
        return;
      });

    this.pageDatas.examHouseId = this.$route.query?.examHouseId ?? "";
    if (this.$route.query?.examHouseId) {
      this.getOnlineTestInfo();
    }
  },
  watch: {},
  computed: {},
  mounted() {
  },
  methods: {
    // 获取 - 考试详情

    getOnlineTestInfo() {
      this.$post("/biz/isec/exam-house/getInfo", { examHouseId: this.pageDatas.examHouseId }, 3000, true, 6)
        .then((res) => {
          this.pageDatas = {
            ...this.pageDatas,
            ...res.data
          }
          // editor.txt.html(res.data?.address ?? '');
        })
        .catch((err) => {
          return;
        });
    },
    // 取消&保存
    cancelSave(cType) {
      if (cType == 1) {
        this.$refs['pageDatas'].validate((valid) => {
          if (valid) {
            let url = '';
            if (this.pageDatas.examHouseId) {
              url = '/biz/isec/exam-house/modify'
            } else {
              url = '/biz/isec/exam-house/insert'
            }
            let cData = { ...this.pageDatas };
            this.$post(url, cData, 3000, true, 6)
              .then((res) => {
                this.$message({
                  type: "success",
                  message: res.message,
                });
                this.$router.back();
              })
              .catch((err) => {
                return;
              });
          }
        });
      } else {
        this.$router.back();
      }
    }
  },
};
</script>
<style lang="less" scoped>
.form-box {
  .el-input {
    width: 300px;
  }
}
</style>
  